import(/* webpackMode: "eager" */ "E:\\VQBits_Windows\\Apps\\AttendbitsRevamp\\frontend\\src\\app\\page.tsx");
